module.exports = __webpack_public_path__ + "img/PorkSpain.7df2eb5e.png";